import { store } from '../store';
import {createApp} from 'vue';
import {sendPetition} from './scripts';

if(document.querySelector('.p-single-activity')){
	var app_courses_module = createApp({
		data(){
			return {
				productType: "",
				productList: [],
				sessionOpen: false
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			},
			sessionInfo(){
				return store.getters['account/sessionInfo']
			}
		},
		watch:{
			clientLogged: function(){
				if (this.clientLogged || sessionStorage.getItem('loginStatus')) {
					this.sessionOpen = true;
				}
			},
		},
		mounted(){
			console.log('Loaded');
			if (this.clientLogged || sessionStorage.getItem('loginStatus')) {
				this.sessionOpen = true;
			}
		},
		methods:{
			goToCheckout: function(event){
				let url = event.currentTarget.dataset['href'];
				this.productType = event.currentTarget.dataset['prodType'];
				let fullPrice = event.currentTarget.dataset['fullPrice'];
				if (!fullPrice) {
					fullPrice = 0;
				}
				let colPrice = event.currentTarget.dataset['colPrice'];
				if (!colPrice) {
					colPrice = 0;
				}
				let prod = {
					id: event.currentTarget.dataset['prodId'],
					title: event.currentTarget.dataset['title'],
					img: event.currentTarget.dataset['img'],
					tag: event.currentTarget.dataset['tag'],
					url: event.currentTarget.dataset['url'],
					fullPrice: fullPrice,
					collegiatPrice: colPrice,
					startDate: event.currentTarget.dataset['start'],
					endDate: event.currentTarget.dataset['end'],
					location: event.currentTarget.dataset['location']
				}
				this.productList.push(prod);
				sessionStorage.setItem('checkoutProductsType', this.productType);
				sessionStorage.setItem('checkoutProducts', JSON.stringify(this.productList));
				window.location.href = url;
			}
		}
	}).mount(document.querySelector('.p-single-activity'));
} 